/* also-available-product-slider.js */
if (!customElements.get('also-available-slider')) {
  customElements.define(
    'also-available-slider',
    class AlsoAvailableSlider extends HTMLElement {
      constructor() {
        super();

        this.enableSliderDesktop = this.dataset.enableSliderDesktop === 'true';
        this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';

        this.selectors = {
          productsWrap: '.products-wrap',
          products: '.products',
          pagination: '.swiper-pagination',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.productsWrap = this.querySelector(this.selectors.productsWrap);
        this.products = this.querySelector(this.selectors.products);
        this.sliderInstance = false;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.enableSliderMobile ? this.initSlider() : this.destroySlider();
        } else {
          this.enableSliderDesktop ? this.initSlider() : this.destroySlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== 'object') {
          const columnsDesktop = parseInt(this.dataset.columnsDesktop) || 1;
          const columnsMobile = parseInt(this.dataset.columnsMobile) || 1;
          
          const productCount = this.querySelectorAll('.swiper-slide').length;
          const currentCols = FoxTheme.config.mqlMobile ? columnsMobile : columnsDesktop;
          const shouldLoop = productCount > currentCols;

          const columnGap = window.getComputedStyle(this.products).getPropertyValue('--f-column-gap');
          const spaceBetween = columnGap !== '' ? parseFloat(columnGap.replace('rem', '')) * 10 : 10;

          // Find navigation elements globally within this component block
          const parentContainer = this.closest('.also-available__container');
          const prevBtn = parentContainer ? parentContainer.querySelector('.swiper-button-prev') : null;
          const nextBtn = parentContainer ? parentContainer.querySelector('.swiper-button-next') : null;
          const paginationEl = parentContainer ? parentContainer.querySelector('.swiper-pagination') : null;

          const isListLayout = this.classList.contains('also-available--horizontal-list') || this.closest('.also-available-products').classList.contains('also-available--horizontal-list');

          this.sliderOptions = {
            // Use 'auto' width ONLY for horizontal lists, otherwise fallback to column math
            slidesPerView: isListLayout ? 'auto' : columnsMobile,
            breakpoints: {
              768: {
                slidesPerView: isListLayout ? 'auto' : columnsDesktop,
              },
            },
            spaceBetween: spaceBetween,
            loop: shouldLoop,
            grabCursor: false,
            allowTouchMove: true,
            autoHeight: true,
            navigation: {
              prevEl: prevBtn,
              nextEl: nextBtn,
            },
            pagination: {
              el: paginationEl,
              type: 'fraction',
            }
          };

          this.productsWrap.classList.add(this.classes.swiper);
          this.products.classList.remove(this.classes.grid);
          this.products.classList.add(this.classes.swiperWrapper);
          
          // Initialize wrapper instance
          this.sliderInstance = new window.FoxTheme.Carousel(this.productsWrap, this.sliderOptions);
          this.sliderInstance.init();

          // Core Override: Manually force Swiper to mount structural targets if broken
          if (this.sliderInstance.slider) {
            const swiperNative = this.sliderInstance.slider;
            
            if (prevBtn && nextBtn) {
              swiperNative.params.navigation.prevEl = prevBtn;
              swiperNative.params.navigation.nextEl = nextBtn;
              swiperNative.navigation.init();
              swiperNative.navigation.update();
            }
            
            if (paginationEl) {
              swiperNative.params.pagination.el = paginationEl;
              swiperNative.params.pagination.type = 'fraction';
              swiperNative.pagination.init();
              swiperNative.pagination.render();
              swiperNative.pagination.update();
            }
          }

          this.fixQuickviewDuplicate();
        }
      }

      destroySlider() {
        if (!this.sliderInstance) return;

        if (this.sliderInstance.slider) {
            this.sliderInstance.slider.destroy(true, true);
        }
        
        this.sliderInstance = false;
        this.productsWrap.classList.remove(this.classes.swiper);
        this.products.classList.remove(this.classes.swiperWrapper);
        this.products.add(this.classes.grid);
        
        this.querySelectorAll('.swiper-slide').forEach(slide => {
          slide.style.width = '';
          slide.style.marginRight = '';
        });
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}